import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DomainTool } from '@/components/tool-page/domain-tool'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['domain-age-checker']

export const Route = createFileRoute('/_site/tools/domain-age-checker')({
  component: DomainAgeCheckerPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  head: () => toolHead(content),
})

function DomainAgeCheckerPage() {
  const { q } = Route.useSearch()
  return (
    <ToolPage content={content}>
      <DomainTool content={content} variant="age" initialDomain={q ?? ''} autoRun={!!q} />
    </ToolPage>
  )
}
